interface InfoField {
    code: string;
    type_id: number;
    value: string;
}

export default (code: string, infoFields: InfoField[]): InfoField | null =>
    infoFields.find((field) => field.code === code) || null;
